import React from 'react';
import { useFormState } from 'react-hook-form';
import { Button, ButtonProps } from '@monorepo/ui-kit';

type Props = Omit<ButtonProps, 'type'>;

const SubmitButton: Component<Props> = ({
  children,
  processing,
  disabled,
  ...props
}) => {
  const { isSubmitting, isValid, isValidating } = useFormState();

  return (
    <Button
      type="submit"
      disabled={!isValid || disabled}
      processing={isSubmitting || isValidating || processing}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
